export async function loadSrp() {
  return await import('@getinsomnia/srp-js');
}
